/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SharedAntdTable from '../../common/shared-antd-table/SharedAntdTable';
import sharedRouterLinks from '../../components/app/shared-routes/sharedRouterLinks';
import UserContext from '../../contexts/user-context/UserProvider';
import { setCountryFormOpenedAction, setDeleteModalOpened, setSelectedTableRow } from '../../redux/countries-slice/countriesSlice';
import CountryTableColumns from './CountryTableColumns';
import queryString from 'query-string';

const CountryPageTable = () => {
  const { search } = useLocation();
  const values = queryString.parse(search);
  const { i18n } = useTranslation();
  const { user } = useContext(UserContext);
  const dispatch = useDispatch();
  const fetchedTableData = useSelector(
    (store) => store.countries.fetchedCountries
  );
  const tablePagination = useSelector((store) => store.countries.tablePagination);
  const isLoadingTableData = useSelector(
    (store) => store.countries.isLoadingTableData
  );

  // map all data to dataSource
  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id
    }));
  };
  useEffect(() => {
    let isMounted = true;

    if (fetchedTableData?.length >= 0) {
      const mappedData = mapDataSource(fetchedTableData);
      if (isMounted) {
        setTableDataSource(mappedData);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [fetchedTableData]);

  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  return (
    <SharedAntdTable
      scroll={1200}
      showHeader={true}
      className={`recent-clients-table ${i18n.dir()}`}
      hasPagination={true}
      tableDataSource={tableDataSource}
      setFormModalOpened={() => dispatch(setCountryFormOpenedAction(true))}
      tableColumns={CountryTableColumns}
      allFetchedTableData={fetchedTableData}
      setSelectedTableRow={(v) => dispatch(setSelectedTableRow(v))}
      setDeleteModalOpened={(v) => dispatch(setDeleteModalOpened(v))}
      isLoadingTableData={isLoadingTableData}
      user={user}
      tablePagination={tablePagination}
      baseTablePageUrl={`${sharedRouterLinks?.appCountryRoute}?searchText=${values?.searchText || ''}&sort=${values?.sort || ''}`}
    />
  );
};

export default CountryPageTable;
